import { SET_EXPAND_ALL, SET_FACILITIES, SET_FACILITIES_LOADING } from './actionTypes';

export const setExpandAllAction = (payload) => {
  return {
    type: SET_EXPAND_ALL,
    payload
  };
};
